import { render, staticRenderFns } from "./childrenage.vue?vue&type=template&id=7b544d2e&"
import script from "./childrenage.vue?vue&type=script&lang=js&"
export * from "./childrenage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b544d2e')) {
      api.createRecord('7b544d2e', component.options)
    } else {
      api.reload('7b544d2e', component.options)
    }
    module.hot.accept("./childrenage.vue?vue&type=template&id=7b544d2e&", function () {
      api.rerender('7b544d2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4KDbAWZsR9hBC/JS/comp/childrenage.vue"
export default component.exports